// src/Pages/DoctorDashboard/ConsultationDetails.js

import React from 'react';
import {
  Box,
  Typography,
  Paper,
  Button,
  List,
  ListItem,
  ListItemText,
} from '@mui/material';
import { useParams, useNavigate } from 'react-router-dom';
import { consultationHistoryData } from '../../data/consultationHistoryMockData';
import { toast } from 'react-toastify'; // Assuming you are using react-toastify for toasts

const ConsultationDetails = () => {
  const { consultationId } = useParams();
  const navigate = useNavigate();

  const consultation = consultationHistoryData.find(
    (cons) => cons.consultationId === parseInt(consultationId)
  );

  // Check if consultation exists
  if (!consultation) {
    // Show toast notification
    toast.error('Consultation not found');
    // Redirect to consultation history after a short delay
    setTimeout(() => navigate('/doctor-dashboard/consultation-history'), 2000);
    return null; // Don't render anything until redirect happens
  }

  return (
    <Box sx={{ padding: 3 }}>
      <Typography variant='h4' sx={{ marginBottom: 3 }}>
        Consultation Details
      </Typography>
      <Paper sx={{ padding: 2 }}>
        <Typography variant='h6'>
          Patient Name: {consultation.patientName}
        </Typography>
        <Typography variant='body1'>Doctor: {consultation.doctor}</Typography>
        <Typography variant='body1'>
          Date: {new Date(consultation.consultationDate).toLocaleString()}
        </Typography>

        <Box sx={{ marginTop: 2 }}>
          <Typography variant='h6'>Symptoms</Typography>
          <List>
            {consultation.symptoms && consultation.symptoms.length > 0 ? (
              consultation.symptoms.map((symptom, index) => (
                <ListItem key={index}>
                  <ListItemText primary={symptom} />
                </ListItem>
              ))
            ) : (
              <Typography variant='body2'>No symptoms recorded.</Typography>
            )}
          </List>
        </Box>

        <Box sx={{ marginTop: 2 }}>
          <Typography variant='h6'>Diagnosis</Typography>
          <Typography variant='body2'>
            {consultation.diagnosis || 'No diagnosis recorded.'}
          </Typography>
        </Box>

        <Box sx={{ marginTop: 2 }}>
          <Typography variant='h6'>Prescriptions</Typography>
          <List>
            {consultation.prescriptions &&
            consultation.prescriptions.length > 0 ? (
              consultation.prescriptions.map((prescription, index) => (
                <ListItem key={index}>
                  <ListItemText
                    primary={`Medication: ${prescription.medication}`}
                    secondary={`Dosage: ${prescription.dosage} - ${prescription.frequency}`}
                  />
                </ListItem>
              ))
            ) : (
              <Typography variant='body2'>
                No prescriptions recorded.
              </Typography>
            )}
          </List>
        </Box>

        <Box sx={{ marginTop: 2 }}>
          <Typography variant='h6'>Tests Ordered</Typography>
          <List>
            {consultation.testsOrdered &&
            consultation.testsOrdered.length > 0 ? (
              consultation.testsOrdered.map((test, index) => (
                <ListItem key={index}>
                  <ListItemText
                    primary={`Test: ${test.testName}`}
                    secondary={`Instructions: ${test.instructions}`}
                  />
                </ListItem>
              ))
            ) : (
              <Typography variant='body2'>No tests ordered.</Typography>
            )}
          </List>
        </Box>

        <Box sx={{ marginTop: 2 }}>
          <Typography variant='h6'>Doctor's Notes</Typography>
          <Typography variant='body2'>
            {consultation.doctorNotes || 'No additional notes.'}
          </Typography>
        </Box>
      </Paper>
      <Button
        variant='contained'
        color='primary'
        sx={{ marginTop: 3 }}
        onClick={() => navigate('/doctor-dashboard/consultation-history')}
      >
        Back to Consultation History
      </Button>
    </Box>
  );
};

export default ConsultationDetails;
